import ModelCard from './ModelCard'
import { MODEL_GRID } from '../../data/modelGrid'

export default function ModelGrid() {
  return (
    <>
      <div className="mt-10 font-mono text-[11px] tracking-[0.1em] text-[rgba(245,245,243,.4)] uppercase">Same models. Kill the meter.</div>
      <p className="mt-2.5 max-w-[520px] text-[1.05rem] leading-[1.5] text-[rgba(245,245,243,.7)]">
        Every model below runs unlimited tokens and unlimited context &mdash; on capacity reserved for your workload.
      </p>
      <div className="mt-[18px] grid grid-cols-1 gap-2.5 sm:grid-cols-2">
        {MODEL_GRID.map((model, i) => (
          <ModelCard key={model.name + i} model={model} />
        ))}
      </div>
    </>
  )
}
